// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Styles
import classes from 'components/Onboarding/IntegrationsList/IntegrationsList.module.scss'

// Assets
import { ReactComponent as IconGoogle } from 'assets/icons/icon_google.svg'
import { ReactComponent as IconMicrosoft } from 'assets/icons/icon_microsoft.svg'
import { ReactComponent as IconMeta } from 'assets/icons/icon_meta.svg'
import { ReactComponent as IconLinkedIn } from 'assets/icons/icon_linkedin.svg'

export default function IntegrationsList() {
  return (
    <div className={clsx(classes.container)}>
      <IconGoogle />
      <IconMicrosoft />
      <IconMeta />
      <IconLinkedIn />
    </div>
  )
}
